/*
 * @Author: zengkai zengkai0702@gamil.com
 * @Date: 2025-08-14 10:26:33
 * @LastEditors: zengkai zengkai0702@gamil.com
 * @LastEditTime: 2025-10-13 15:48:51
 * @FilePath: /lxk_crm_web_h5/src/router/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createRouter, createWebHistory } from "vue-router";
import cookie from "@/utils/cookie";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/home/index.vue"),
    meta: {
      keepAlive: true, // 需要缓存
      title: "首页",
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login.vue"),
  },
  {
    path: "/trial",
    name: "trial",
    component: () => import("@/views/trial/index.vue"),
  },
  {
    path: "/trial/login",
    name: "trialLogin",
    component: () => import("@/views/trial/login.vue"),
  },
  {
    path: "/trial/orders",
    name: "trialOrders",
    component: () => import("@/views/trial/orders.vue"),
    meta: {
      requiresAuth: true,
      keepAlive: true,
      title: "选择客户订单",
    },
  },
  //   MyCenter  我的
  {
    path: "/myCenter",
    name: "myCenter",
    component: () => import("@/views/myCenter.vue"),
    meta: {
      keepAlive: true,
      title: "我的",
    },
  },
  //   corpDetail  客户详情
  {
    path: "/corpDetail",
    name: "corpDetail",
    component: () => import("@/views/corpDetail/index.vue"),
    meta: {
      keepAlive: true,
      title: "客户详情",
    },
  },
  // followRecord,
  {
    path: "/followRecord",
    name: "followRecord",
    component: () => import("@/views/followRecord.vue"),
    meta: {
      keepAlive: false,
      title: "跟进记录",
    },
  },
  {
    path: "/addPhone",
    name: "addPhone",
    component: () => import("@/views/addPhone.vue"),
    meta: {
      keepAlive: false, // 需要缓存
      title: "加电话",
    },
  },
  // orderAddPhone 点击底部footer 加电话
  {
    path: "/orderAddPhone",
    name: "orderAddPhone",
    component: () => import("@/views/orderAddPhone/index.vue"),
    meta: {
      keepAlive: true, // 需要缓存
      title: "加电话",
    },
  },
  {
    path: "/callLog",
    name: "callLog",
    component: () => import("@/views/callLog/index.vue"),
  },
  {
    path: "/phoneEdit",
    name: "phoneEdit",
    component: () => import("@/views/phoneEdit/index.vue"),
  },
  {
    path: "/addPhoneLog",
    name: "addPhoneLog",
    component: () => import("@/views/addPhoneLog/index.vue"),
  },
  {
    path: "/riskLevelLog",
    name: "riskLevelLog",
    component: () => import("@/views/riskLevelLog/index.vue"),
  },
  {
    path: "/settleDetail",
    name: "settleDetail",
    component: () => import("@/views/settleDetail/index.vue"),
  },
  {
    path: "/repaymentPlan",
    name: "repaymentPlan",
    component: () => import("@/views/repaymentPlan/index.vue"),
  },
  {
    path: "/repaymentDetails",
    name: "repaymentDetails",
    component: () => import("@/views/repaymentDetails/index.vue"),
  },
  {
    path: "/historyList",
    name: "historyList",
    component: () => import("@/views/historyList/index.vue"),
  },
  {
    path: "/cityInfo",
    name: "cityInfo",
    component: () => import("@/views/cityInfo/index.vue"),
  },
  {
    path: "/cityHistory",
    name: "cityHistory",
    component: () => import("@/views/cityHistory/index.vue"),
  },
  {
    path: "/addFieldVisit",
    name: "addFieldVisit",
    component: () => import("@/views/addFieldVisit/index.vue"),
  },
  {
    path: "/imgListData",
    name: "imgListData",
    component: () => import("@/views/imgListData/index.vue"),
  },
  {
    path: "/loanAfterEdit",
    name: "loanAfterEdit",
    component: () => import("@/views/loanAfterEdit/index.vue"),
  },
  {
    path: "/fileView",
    name: "fileView",
    component: () => import("@/views/fileView/index.vue"),
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});
// 添加路由守卫
router.beforeEach((to, from, next) => {
  // 直接从 localStorage 读取 token（因为你使用了 persist: true）
  const storeData = localStorage.getItem("storeData");
  let token = "";

  if (storeData) {
    try {
      const parsedData = JSON.parse(storeData);
      token = parsedData.token || "";
    } catch (error) {
      console.error("解析 localStorage 数据失败:", error);
    }
  }
  token = token || cookie.getToken() || "";

  // 检查路由是否需要认证
  if (to.meta.requiresAuth && !token) {
    // 避免重复跳转
    if (to.path !== "/login" && to.path !== "/trial/login") {
      // 清除 localStorage 中的数据
      localStorage.removeItem("storeData");
      next(to.path.startsWith("/trial") ? "/trial/login" : "/login");
    } else {
      next(); // 如果已经在登录页，就继续
    }
  } else {
    next(); // 不需要认证，或者已经认证，就继续
  }
});

export default router;
